import React, { createContext, useReducer, useContext } from 'react';

/**
 * Socrates V2 Context
 * 새로운 API 기반의 소크라테스 상태 관리
 */

const SocratesV2Context = createContext();

const initialState = {
  currentInterview: null,     // Interview 객체
  messages: [],                // ChatMessage[]
  isLoading: false,            // 일반 로딩 (입력창 로딩바용)
  isChatLoading: false,        // 채팅 로딩 (로딩 버블용)
  isRestarting: false,         // 면접 재시작 로딩 (처음부터 버튼)
  isGeneratingResult: false,   // 결과 생성 로딩
  isPausing: false,            // 정지 요청 중 플래그 (메시지 추가 방지)
  abortController: null,       // API 요청 취소용 AbortController
  error: null
};

/**
 * Socrates V2 Reducer
 */
function socratesV2Reducer(state, action) {
  switch (action.type) {
    case 'SET_INTERVIEW':
      return {
        ...state,
        currentInterview: action.payload
      };

    case 'SET_MESSAGES':
      return {
        ...state,
        messages: action.payload
      };

    case 'ADD_MESSAGE':
      return {
        ...state,
        messages: [...state.messages, action.payload]
      };

    case 'UPDATE_MESSAGE':
      return {
        ...state,
        messages: state.messages.map(msg =>
          msg.id === action.payload.id ? { ...msg, ...action.payload } : msg
        )
      };

    case 'SET_LOADING':
      return {
        ...state,
        isLoading: action.payload
      };

    case 'SET_CHAT_LOADING':
      return {
        ...state,
        isChatLoading: action.payload
      };

    case 'SET_RESTARTING':
      return {
        ...state,
        isRestarting: action.payload
      };

    case 'SET_GENERATING_RESULT':
      return {
        ...state,
        isGeneratingResult: action.payload
      };

    case 'SET_PAUSING':
      return {
        ...state,
        isPausing: action.payload
      };

    case 'SET_ABORT_CONTROLLER':
      return {
        ...state,
        abortController: action.payload
      };

    case 'SET_ERROR':
      return {
        ...state,
        error: action.payload
      };

    case 'CLEAR_ERROR':
      return {
        ...state,
        error: null
      };

    case 'RESET':
      // isRestarting, isGeneratingResult 상태는 유지 (로딩 화면이 사라지지 않도록)
      // abortController가 있으면 취소
      if (state.abortController) {
        state.abortController.abort();
      }
      return {
        ...initialState,
        isRestarting: state.isRestarting,
        isGeneratingResult: state.isGeneratingResult
      };

    default:
      return state;
  }
}

/**
 * Socrates V2 Provider
 */
export const SocratesV2Provider = ({ children }) => {
  const [state, dispatch] = useReducer(socratesV2Reducer, initialState);

  return (
    <SocratesV2Context.Provider value={{ state, dispatch }}>
      {children}
    </SocratesV2Context.Provider>
  );
};

/**
 * Socrates V2 Hook
 */
export const useSocratesV2 = () => {
  const context = useContext(SocratesV2Context);
  if (!context) {
    throw new Error('useSocratesV2 must be used within SocratesV2Provider');
  }
  return context;
};
